module.exports = __webpack_public_path__ + "img/9.e2151e55.jpg";